import type {FieldValue} from 'typings/portaro.be.types';
import {isIdentified} from 'shared/utils/types-utils';

export function ofCode(code: string): (f: { fields: any; code: string }) => boolean {
    return (f) => f.fields && f.code === code;
}

export function getRecordIdFromFieldValue(value: FieldValue): string {
    if (isIdentified(value)) {
        return value.id;
    }

    return '';
}